import React from "react";
import { useTranslation } from "react-i18next";
import { CogIcon } from "@heroicons/react/outline";
import UpTray from "assets/images/icons/UpTray.svg";
import { useAuth0 } from "@auth0/auth0-react";
import useSignout from "hooks/useSignout";
import ActionMenu from "components/ActionMenu";
import { userStore } from "store/UserStore";
import ConfirmModal from "components/ConfirmModal";
import Button from "components/Button";
import { IconLogout } from "@tabler/icons-react";

const ProfileMenu = ({
  openSettings,
  onboarding,
}: {
  openSettings?: () => void;
  onboarding?: boolean;
}) => {
  const { t } = useTranslation();
  const { user } = useAuth0();
  const { userProfile } = userStore;
  const signOut = useSignout();

  const menuItems = [
    <div key={0} className="flex">
      <CogIcon width={15} className="mr-3" />
      {t("commons.settings")}
    </div>,
    <div key={1} className="flex">
      <img alt="logout" src={UpTray} className="rotate-90 mr-3" width={15} />
      {t("commons.logout")}
    </div>,
  ];

  const actions = openSettings ? [() => openSettings(), () => signOut()] : [];

  const [open, setOpen] = React.useState(false);

  return (
    <>
      <ConfirmModal
        onConfirm={signOut}
        open={open}
        close={() => setOpen(false)}
        confirmButtonTitle={t("commons.yes")}
        cancelTitle={t("commons.cancel")}
        title={t("commons.logout")}
        descriptionMesage={t("commons.areYouSure")}
      />
      {onboarding ? (
        <Button
          type="gray"
          onClick={() => setOpen(true)}
          test-id="logout_button"
          className="m-4"
          leadingIcon={<IconLogout />}
          width="fit-content"
        >
          {t("commons.logout")}
        </Button>
      ) : (
        <div className="flex justify-between relative items-center text-left w-full">
          <div className="flex items-center">
            <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-gray-500">
              <span className="font-medium leading-none text-white text-xs">
                {`${userProfile?.first_name
                  ?.toUpperCase()
                  .charAt(0)}${userProfile?.last_name
                  ?.toUpperCase()
                  .charAt(0)}`}
              </span>
            </span>
            <span className="pl-2">
              {userProfile ? userProfile.first_name : user?.nickname}
            </span>
          </div>
          <ActionMenu
            items={menuItems}
            onSelect={(index) =>
              index === 1 ? setOpen(true) : actions[index]()
            }
            direction="top"
          ></ActionMenu>
        </div>
      )}
    </>
  );
};

export default ProfileMenu;
